import { useRef, useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { API } from "@/api";

export const imagesOf = (p) => (p?.images?.length ? p.images : p?.image ? [p.image] : []);

export default function ProductImages({ product, testid = "product-images", rounded = "rounded-xl" }) {
  const imgs = imagesOf(product);
  const ref = useRef();
  const [idx, setIdx] = useState(0);
  if (!imgs.length) return null;

  const go = (i) => {
    const el = ref.current;
    if (el) { el.scrollTo({ left: i * el.clientWidth, behavior: "smooth" }); }
  };
  const onScroll = () => {
    const el = ref.current;
    if (el) { setIdx(Math.round(el.scrollLeft / el.clientWidth)); }
  };

  return (
    <div className={`relative w-full aspect-square overflow-hidden bg-[var(--jjs-surface-soft)] ${rounded}`} data-testid={testid}>
      <div ref={ref} onScroll={onScroll} className="flex h-full w-full overflow-x-auto snap-x snap-mandatory no-scrollbar">
        {imgs.map((src, i) => (
          <img key={src + i} src={`${API}/files/${src}`} alt={`${product.name || "Product"} ${i + 1}`} loading="lazy" className="h-full w-full shrink-0 snap-center object-cover" />
        ))}
      </div>
      {imgs.length > 1 && (
        <>
          <button type="button" onClick={(e) => { e.stopPropagation(); go(Math.max(0, idx - 1)); }} className="absolute left-2 top-1/2 -translate-y-1/2 h-8 w-8 rounded-full bg-white/85 shadow flex items-center justify-center text-slate-700" data-testid={`${testid}-prev`}><ChevronLeft size={16} /></button>
          <button type="button" onClick={(e) => { e.stopPropagation(); go(Math.min(imgs.length - 1, idx + 1)); }} className="absolute right-2 top-1/2 -translate-y-1/2 h-8 w-8 rounded-full bg-white/85 shadow flex items-center justify-center text-slate-700" data-testid={`${testid}-next`}><ChevronRight size={16} /></button>
          <div className="absolute bottom-2 inset-x-0 flex justify-center gap-1.5">
            {imgs.map((_, i) => <span key={i} className={`h-1.5 rounded-full transition-[width,background-color] ${i === idx ? "w-4 bg-[var(--jjs-gold)]" : "w-1.5 bg-white/80"}`} />)}
          </div>
        </>
      )}
    </div>
  );
}
